module.exports = __webpack_public_path__ + "img/infor4.f8058101.png";